import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';

// web routing
const GuidanceToolPage = Loadable(lazy(() => import('features/guidance-tool')));

// ==============================|| AUTH ROUTING ||============================== //

const GuidanceToolRoutes = {
    path: '/',
    children: [
        {
            name: 'e-Advisor',
            path: '/e-Advisor',
            element: <GuidanceToolPage />
        }
    ]
};

export default GuidanceToolRoutes;
